module.exports = __webpack_public_path__ + "media/addScore.1333bc30.mp3";